import { Component, ChangeDetectionStrategy, HostListener, ElementRef, inject, input, viewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import { Language, SetActiveLanguage } from '@teamfoster/sdk/language-ngrx';

@Component({
    selector: 'app-lang-switcher',
    templateUrl: './lang-switcher.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class LangSwitcherComponent {
  private store = inject(Store);

  readonly dropdownpanel = viewChild<ElementRef>('dropdownpanel');
  readonly languages = input<Language[]>([]);
  readonly activeLang = input.required<string>();
  dropdownOpen = false;

  @HostListener('document:mousedown', ['$event'])
  onGlobalClick(event: Event): void {
    if (!this.dropdownpanel()?.nativeElement.contains(event.target)) {
      this.dropdownOpen = false;
    }
  }

  setLanguage(lang: Language) {
    this.store.dispatch(SetActiveLanguage({ activeLang: lang.code }));
  }

  getFlag(code: string) {
    return `/assets/img/country-flags/${code.split('-')?.[1]?.toLowerCase()}.svg`;
  }

  toggleDropdown() {
    this.dropdownOpen = !this.dropdownOpen;
  }

  get activeLanguage(): Language {
    const languages = this.languages();
    return languages.find(a => a.code === this.activeLang()) ?? languages[0] ?? { code: 'en-GB', name: 'English' };
  }
}
